<template>
  <div style="width: 600px;margin: 30px auto 0;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="200px"
    >
      <el-form-item
        label="公司名称"
        prop="groupName"
      >
        <el-input
          v-model.trim="form.groupName"
          clearable
          readonly
          maxlength="256"
          @change="(value)=>{form.groupName = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="注册地址"
        prop="registeredAddress"
      >
        <el-input
          v-model="form.registeredAddress"
          placeholder="请输入注册地址"
          maxlength="512"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="注册资金（万元）"
        prop="registeredCapital"
      >
        <el-input
          v-model="form.registeredCapital"
          placeholder="请输入注册资金（万元）"
          maxlength="255"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="统一社会信用代码注册时间"
        prop="uniformSocialCreditTime"
      >
        <el-date-picker
          v-model="form.uniformSocialCreditTime"
          type="date"
          :validate-event="false"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd 00:00:00"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item
        label="经营范围"
        prop="businessScope"
      >
        <el-input
          v-model="form.businessScope"
          placeholder="请输入经营范围"
          type="textarea"
          maxlength="2000"
          autosize
          clearable
        />
      </el-form-item>
      <el-form-item
        label="企业成立时间"
        prop="establishmentDate"
      >
        <el-date-picker
          v-model="form.establishmentDate"
          type="date"
          :validate-event="false"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd 00:00:00"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item
        label="营业执照注册时间"
        prop="registerDate"
      >
        <el-date-picker
          v-model="form.registerDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd 00:00:00"
          :validate-event="false"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item
        label="营业执照期限开始日期"
        prop="businessLicenseStartDatetime"
      >
        <el-date-picker
          v-model="form.businessLicenseStartDatetime"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd 00:00:00"
          :validate-event="false"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item
        label="营业执照期限结束日期"
        prop="businessLicenseEndDatetime"
      >
        <el-date-picker
          v-model="form.businessLicenseEndDatetime"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd 00:00:00"
          :validate-event="false"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item
        label="所属辖区"
        prop="countrySubdivisionCode"
      >
        <el-cascader
          ref="countrySubdivisionCode"
          v-model="form.countrySubdivisionCode"
          :options="countyOptions"
          :props="{
            value: 'countyCode',
            label: 'countyName',
            children: 'children'
          }"
          @change="handleChange"
        />
      </el-form-item>
      <el-form-item
        label="法人姓名"
        prop="legalPersonName"
      >
        <el-input
          v-model="form.legalPersonName"
          placeholder="请输入法人姓名"
          maxlength="50"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="法人手机号"
        prop="legalPersonTelephoneNumber"
      >
        <el-input
          v-model="form.legalPersonTelephoneNumber"
          placeholder="请输入法人手机号"
          maxlength="60"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="联系人名称"
        prop="contactName"
      >
        <el-input
          v-model="form.contactName"
          placeholder="请输入联系人名称"
          maxlength="255"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="联系人手机号"
        prop="contactMobileTelephoneNumber"
      >
        <el-input
          v-model="form.contactMobileTelephoneNumber"
          placeholder="请输入联系人手机号"
          maxlength="50"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="电信业务经营许可证编号"
        prop="ipcnum"
      >
        <el-input
          v-model="form.ipcnum"
          placeholder="请输入电信业务经营许可证编号"
          maxlength="50"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="三级等保备案编号"
        prop="psnrnum"
      >
        <el-input
          v-model="form.psnrnum"
          placeholder="请输入三级等保备案编号"
          maxlength="50"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="是否为分公司"
        prop="branch"
      >
        <el-select
          v-model="form.branch"
          placeholder="请选择"
          :validate-event="false"
          @change="isBranchFun"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="form.branch=='1'"
        label="总公司名称"
        prop="controllingName"
      >
        <el-input
          v-model.trim="form.controllingName"
          placeholder="请输入总公司名称"
          maxlength="255"
          clearable
          @change="(value)=>{form.controllingName = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        v-if="form.branch=='1'"
        label="总公司所属辖区"
        prop="controllingAreaCode"
      >
        <el-cascader
          ref="controllingAreaCode"
          v-model="form.controllingAreaCode"
          :options="countyOptions"
          :props="{
            value: 'countyCode',
            label: 'countyName',
            children: 'children'
          }"
          @change="handleChange"
        />
      </el-form-item>
      <el-form-item
        label="是否上报"
        prop="report"
      >
        <el-select
          v-model="form.report"
          placeholder="请选择"
          disabled
        >
          <el-option
            v-for="item in reportOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="getLimit('sysSetting_js_submit_button')"
          type="primary"
          @click="funcSubmitJs"
        >
          确 定
        </el-button>
        <el-button
          v-if="getLimit('sysSetting_js_report_button')&&form.report == 0"
          type="primary"
          @click="funcSubmitRe"
        >
          上 报
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import {validatePhone} from "@/utils/validate";
  export default {
    name: "PartrGroupJsReport",
    data () {
      return {
        options: [{
          value: '0',
          label: '否'
        }, {
          value: '1',
          label: '是'
        }],
        reportOptions: [{
          value: 0,
          label: '否'
        }, {
          value: 1,
          label: '是'
        }],
        countyOptions: this.$store.state.components.areaOptions,
        form:{
          groupName:'',
          registeredAddress:'',
          registeredCapital:'',
          uniformSocialCreditTime:'',
          businessScope:'',
          establishmentDate:'',
          registerDate:'',
          businessLicenseStartDatetime:'',
          businessLicenseEndDatetime:'',
          countrySubdivisionCode:'',
          legalPersonName:'',
          legalPersonTelephoneNumber:'',
          contactName:'',
          contactMobileTelephoneNumber:'',
          ipcnum:'',
          psnrnum:'',
          branch:'',
          controllingName:'',
          controllingAreaCode:'',
          report:''
        },
        rules: {
          registeredAddress: [
            { required: true, message: '请输入注册地址', trigger: 'blur' },
            {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
          ],
          registeredCapital: [
            { required: true, message: '请输入注册资金', trigger: 'blur' },
          ],
          uniformSocialCreditTime: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          businessScope: [
            { required: true, message: '请输入经营范围', trigger: 'blur' },
          ],
          establishmentDate: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          registerDate: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          businessLicenseStartDatetime: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          businessLicenseEndDatetime: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          countrySubdivisionCode: [
            { required: true, message: '请选择所属辖区', trigger: 'change' }
          ],
          legalPersonTelephoneNumber: [
            {
              required: true,
              validator(rule, value, callback) {
                validatePhone(value)
                  ? callback()
                  : callback(new Error("请输入正确的手机号"));
              },
              trigger: "blur"
            }
          ],
          contactName: [
            { required: true, message: '请输入联系人名称', trigger: 'blur' },
          ],
          contactMobileTelephoneNumber: [
            {
              required: true,
              validator(rule, value, callback) {
                validatePhone(value)
                  ? callback()
                  : callback(new Error("请输入正确的手机号"));
              },
              trigger: "blur"
            }
          ],
          ipcnum: [
            { required: true, message: '请输入电信业务经营许可证编号', trigger: 'blur' },
          ],
          psnrnum: [
            { required: true, message: '请输入三级等保备案编号', trigger: 'blur' },
          ],
          branch: [
            { required: true, message: '请选择是否为分公司', trigger: 'change' }
          ],
          controllingName: [
            { required: false, message: '请输入总公司名称', trigger: 'blur' },
          ],
          controllingAreaCode: [
            { required: false, message: '请选择总公司所属辖区', trigger: 'change' },
          ],
        }
      }
    },
    created() {
      this.getInfo();
      // this.Seladdress();
    },
    methods: {
      getInfo() {
        return request({
          url: `/ntocc-basic-api/partyGroup/one`,
          method: "get"
        }).then(response => {
          if (response.data) {
            this.form = response.data;
            this.form.branch = '0'
          }
        });
      },
      getLabels(node) {
        if (node instanceof Array) {
          node = node[0];
        }
        if (node) {
          return node.value;
        }
      },
      handleChange() {
        let countrySubdivisionCode = this.getLabels(
          this.$refs["countrySubdivisionCode"].getCheckedNodes()
        );
        this.form.countrySubdivisionCode = countrySubdivisionCode;
        if (this.form.branch=='1'){
          let controllingAreaCode = this.getLabels(
            this.$refs["controllingAreaCode"].getCheckedNodes()
          );
          this.form.controllingAreaCode = controllingAreaCode;
        }
      },
      isBranchFun(value){
        if (value == '1'){
          this.rules.controllingName[0].required = true
          this.rules.controllingAreaCode[0].required = true
        }
      },
      // 提交
      funcSubmitJs() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            const data = this.form;
            const rLoading = this.openLoading();
            if (data.code) {
              request({
                url: "/ntocc-basic-api/partyGroup",
                method: "put",
                params: data
              }).then(response => {
                this.getInfo();
                rLoading.close();
                this.$message({ message: response.msg, type: "success" });
              });
            } else {
              request({
                url: "/ntocc-basic-api/partyGroup",
                method: "post",
                params: data
              }).then(response => {
                this.getInfo();
                rLoading.close();
                this.$message({ message: response.msg, type: "success" });
              });
            }
          } else {
            return false;
          }
        });
      },
      funcSubmitRe(){
        const rLoading = this.openLoading();
        request({
          url: "/ntocc-basic-api/report/reportBranchOfJiangSu",
          method: "get",
          params: {
            branchCode: this.form.code
          }
        }).then(response => {
          this.getInfo();
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
        });
      }
    }
  }
  

</script>

<style scoped>

</style>
